import type { PlatformComponentProps } from "@b2bportal/core-types";
import { ReturnPage, useReturnPage, useReturnPageRoute } from "@tenant/flights";
import {
  CoreFlightExchangeSteps,
  FlightsExchangeNavigationFlow,
} from "../../navigationFlow";

export const ExchangeReturnPageRoute = ({
  className,
  children,
}: PlatformComponentProps) => {
  const params = useReturnPageRoute();
  const goToNextStep = FlightsExchangeNavigationFlow.useGoToNextStep(
    CoreFlightExchangeSteps.RETURN
  );
  const data = useReturnPage({ ...params, goToNextStep });
  return (
    <ReturnPage className={className} {...data}>
      {children}
    </ReturnPage>
  );
};
